import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';
import ChildrenType from '../../types/ChildrenType';

const PageHeader = ({ title, subtitle, children, cypressId }) => (
  <Flex alignItems="center" data-cy={cypressId} justifyContent="space-between" mb={4}>
    <Flex>
      <Text color={colors.greyScale['900']} mr={4} textStyle="displaySm">
        {title}
      </Text>
      {subtitle && <Text alignSelf="end" color="greyScale.600" pb={2} textStyle="bodyLg500">{subtitle}</Text>}
    </Flex>
    <Flex alignItems="center">
      {children}
    </Flex>
  </Flex>
);

PageHeader.propTypes = {
  /** Title of page */
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  /** Right-aligned element, i.e. subheading, menu, or icon */
  children: ChildrenType,
  cypressId: PropTypes.string
};

export default PageHeader;
